<template>
    <div>
   
        <div class="col-12 rules_section">
          <div>
            <h3 v-if="language === 'english'">english.h3-1</h3>
            <h3 v-else-if="language === 'spanish'">spanish.h3-1</h3>
            
            <p>
              Guess the first 16 matchups of the season by clicking on the game and selecting the opponent.
            </p>
            <h3>Step Two:</h3>
            <p>
              Share your results on social media using #SpursLoteria
            </p>
            <h3>Step Three:</h3>
            <p>
              Five random participants will be selected on Sunday, August 11th to win tickets to Opening Night.
            </p>
            <a href="https://www.nba.com/spurs/spurs-loteria-rules" target="_blank">Terms &#38; Conditions</a>
          </div>
        </div>
    </div>
</template>

<script>
import english from '../assets/json/languages/english.json'
import spanish from '../assets/json/languages/spanish.json'
export default {
  name: 'PlayerTutorialView',
  props: ['language']
}
</script>
